import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from '../AppContext/AuthContext';


export function Auth({children}){
    if(!localStorage.getItem("token")) return <Navigate to='/sign-in' />
    return <>{children}</> 
}